export default class SubMenu {
    items;
    containers;
    constructor(el) {
        this.items = el.querySelectorAll('.js-sub-menu__item');
        this.containers = el.querySelectorAll('.js-sub-menu__content');
        // Skipp if no items
        if (this.items.length === 0)
            return;
        for (let item of this.items) {
            item.addEventListener("mouseover", this.toggleActiveItem.bind(this));
        }
    }
    toggleActiveItem(event) {
        const sidebarItem = event.currentTarget;
        const activeId = sidebarItem.getAttribute('data-sub-menu-id');
        for (let container of this.containers) {
            const containerId = container.getAttribute('data-sub-menu-id');
            if (activeId === containerId)
                container.classList.add('is-visible');
            else
                container.classList.remove('is-visible');
        }
        for (let item of this.items) {
            const itemId = item.getAttribute('data-sub-menu-id');
            if (activeId === itemId)
                item.classList.add('is-active');
            else
                item.classList.remove('is-active');
        }
    }
}
